import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-communication-chat-check-icon',
  templateUrl: './communication-chat-check.component.html'
})
export class CommunicationChatCheckComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
